import { ACT_STATS_CHANGE } from "./ActionTypes";
import StatsService from "../provider/stats/StatsService";
import {loading} from "./AppActions"

/*** ACTIONS STATS ******/
export function actionGetStatsByClient(filter, order, succesCallback, errorCallback) {
	return (dispatch, getStore) => {
			loading(true)(dispatch,getStore)
			StatsService.getStatsByClient(filter,order,getStore().app.app).then((response) => {
					console.log("ACTION", response)
					dispatch({
							type:ACT_STATS_CHANGE,
							props: {statsByClient:response}
					})
					succesCallback&&succesCallback()
			}).catch(errorCallback)
			.finally(()=>{loading(false)(dispatch,getStore)})
	};
}

export function actionGetStatsByClientDetail(filter, order, succesCallback, errorCallback) {
	return (dispatch, getStore) => {
			loading(true)(dispatch,getStore)
			StatsService.getStatsByClientDetail(filter,order,getStore().app.app).then((response) => {
					console.log("ACTION actionGetStatsByClientDetail", response)
					dispatch({
							type:ACT_STATS_CHANGE,
							props: {statsByClientDetail:response}
					})
					succesCallback&&succesCallback()
			}).catch(errorCallback)
			.finally(()=>{loading(false)(dispatch,getStore)})
	};
}

export function actionGetStatsByEvent(filter, order, succesCallback, errorCallback) {
	return (dispatch, getStore) => {
			loading(true)(dispatch,getStore)
			StatsService.getStatsByEvent(filter,order,getStore().app.app).then((response) => {
					console.log("ACTION", response)
					dispatch({
							type:ACT_STATS_CHANGE,
							props: {statsByEvent:response}
					})
					succesCallback&&succesCallback()
			}).catch(errorCallback)
			.finally(()=>{loading(false)(dispatch,getStore)})
	};
}




// WEBPACK FOOTER //
// ./src/actions/StatsActions.js